var _rect, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 66,
    viewBox: "0 0 45 66",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 45,
    height: 66,
    fill: "url(#pattern0_53_63)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_53_63",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_53_63",
    transform: "matrix(0.0111111 0 0 0.00757576 0 0.159091)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_53_63",
    width: 90,
    height: 90,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFoAAABaCAYAAAA4qEECAAAACXBIWXMAAAsTAAALEwEAmpwYAAADTUlEQVR4nO2avYvUQBjG1w9EEMEvULDQwsZGEEWw0kYrrez8aCy1s/EP0OIKiyssFAQFtbLSShutBNHGxkZFBYsFF26T50nWD9SR4U6U5TaZJJOdye3zgxcWbpPs/Pbdycxz6fWEEEIIIYQQQgghhBBCCCGER4bD4SaSz0kaFSc6APAKwLZGsvv9/gYATySakyQ/GwwGG710tjFmHckHks1x0Y+MMevrCF1V8Lc1JG9LNv928h1jzNo6LnsA7pYdDODarMsGcN0Ys7qkKW9NFO36cwBwOfRgGa7mXKfZMtFOEzyACwB+zVAX/yZ5qcrCoVS065KF5GkAP2ZA8s80Tc8XuUiSZPP4UthJ9FK9yfN8Z9EF0jQ9AWC0giV/A3CqyEGWZTsAvB4/topoWx+TJNlTdCEAR0imoaXQf2UkjxWNfTgc7ib5brnjq4q232qf5L6iC+Z5foDkIAI5xlMtpGl6uKTB9gL4POkclUX7ujA7Uo6NdbCsseqKtpVlWXbc4af0NrQs1q/SqZLkUZepsolo+21/L7s5kNy+3M2B8ZfLzf8kgK8u52sk2nW507XkD8BLh+XsmSrL2caiKy7gH4eW6DCW0g0ayYtVN2heRNfZkjLOai1y8C3aOWRheKnjn7vVEM276Gl8aPqX3HpztCK6Y8nf3DSmuzZFR538oUYCF63oWJM/1EzgohYdW/KHBglcF0THkvxlTRK4rogOnfwthAzCpio61IDhKYHrmmjjkvyNRqNdnpK/D74SuC6KNlNK/rwmcJ0UzZaTvzYSuM6KZkvJH4CnbSRwnRZN/1vhhzFu/WMSbQDMOzzzd7PgHDfse0rCrPkQY4tKNB0eGPzvBmYziC+27Gu7syw6xp7TnjvUuKITzSaPwEb8D4dYRRtfD3XH8vB8tKK5WC+SJNlSV7I91p4jgnFEL9oA+JQkyaGqkrMs20/yfejP3xnRXJRtd25XXLo7TdOtJK9OY7e34kTzXwHAPZJnbUhkc2NbS6/PAbhv3xPB5+y8aNPVkmhKtAndhepohhenqYPhpWqOpkSb0B2njmZ4SZo6GF6g5mjGVdqwUKJN6C5URzO8OE0dDC9VczQjFC2EEEIIIYQQQgghhBBCCCF65fwBkMHxfLzDnnwAAAAASUVORK5CYII="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/Email.d6fc6c387ebbc6f9ae48e77318a42ecc.svg";
export { ForwardRef as ReactComponent };